"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inlineEditableDiv = require("./inlineEditableDiv");

var _inlineEditableDiv2 = _interopRequireDefault(_inlineEditableDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _inlineEditableDiv2.default;